import { render, staticRenderFns } from "./RPTreeselect.vue?vue&type=template&id=4e4602d2&"
import script from "./RPTreeselect.vue?vue&type=script&lang=js&"
export * from "./RPTreeselect.vue?vue&type=script&lang=js&"
import style0 from "@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./RPTreeselect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports